<template>
  <div id="order">
    <a-modal title="选取位置"
             style="top: 20px"
             :width="800"
             v-model="mapVisible"
             @ok="mapVisible = false"
             @cancel="mapVisible = false">
      <lonlat-map ref="lonlatMaps"
                  @handleMapOk="handleMapOk"></lonlat-map>
    </a-modal>
    <a-modal title="派发工单"
             :visible="showTubeView"
             :width="800"
             destroyOnClose
             @ok="handleOk"
             @cancel="closeTubeView">
      <a-form-model class="log-form"
                    :model="addOrUpdateForm"
                    ref="addOrUpdateForm"
                    :rules="rules"
                    :label-col="{ span: 6 }"
                    :wrapper-col="{ span: 14 }">
        <a-row class="form-row"
               type="flex"
               justify="center"
               :gutter="4">
          <!-- <a-col :md="12" :sm="24">
            <a-form-model-item label="关联事件">
              <span>{{ addOrUpdateForm.eventNo }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24"> </a-col> -->
          <a-col :md="12"
                 :sm="24">
            <a-form-model-item label="工单号">
              <a-input disabled
                       placeholder="自动生成"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :md="12"
                 :sm="24">
            <a-form-model-item label="工单名称"
                               prop="workName">
              <a-input v-model="addOrUpdateForm.workName" />
            </a-form-model-item>
          </a-col>
          <!-- <a-col :md="12" :sm="24">
            <a-form-model-item label="设备名称" prop="deviceName">
              <a-input v-model="addOrUpdateForm.deviceName" />
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item label="设备编号" prop="deviceNo">
              <a-input v-model="addOrUpdateForm.deviceNo" />
            </a-form-model-item>
          </a-col> -->
          <a-col :md="12"
                 :sm="24">
            <a-form-model-item label="负责人"
                               prop="principal">
              <a-select show-search
                        option-filter-prop="children"
                        style="width: 200px"
                        :filter-option="filterOption"
                        v-model="addOrUpdateForm.principal"
                        @change="handleChange">
                <a-select-option v-for="item in userlist"
                                 :key="item.id">{{ item.realName }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :md="12"
                 :sm="24">
            <a-form-model-item label="维修泵房"
                               prop="pumpId">
              <a-select show-search
                        option-filter-prop="children"
                        style="width: 200px"
                        :filter-option="filterOption"
                        v-model="addOrUpdateForm.pumpId"
                        @change="pumpChange">
                <a-select-option v-for="item in OrderTypeList"
                                 :key="item.key">{{ item.title }}</a-select-option>
              </a-select>
              <!-- <a-select
                placeholder="请选择维修泵房"
                show-search
                option-filter-prop="children"
                style="width: 200px"
                :filter-option="filterOption"
                v-model="addOrUpdateForm.pumpId"
              >
                <a-select-option v-for="item in OrderTypeList" :key="item.id">{{ item.title }}</a-select-option>
              </a-select> -->
            </a-form-model-item>
            <!-- <a-form-model-item label="维修地点">
              <a-button type="primary" @click="showmap">添加位置</a-button>
            </a-form-model-item> -->
          </a-col>
          <!-- <div
            style="width: 100%; text-align: left; height: 50px; line-height: 50px; margin-left: 35px; margin-top: -20px"
            v-if="addOrUpdateForm.address"
          >
            维修地点: {{ addOrUpdateForm.address }}
          </div> -->
          <a-col :md="24"
                 :sm="24">
            <a-form-model-item label="其他维修人员"
                               :label-col="{ span: 3 }"
                               :wrapper-col="{ span: 20 }"
                               prop="maintenancePersons">
              <a-button @click="addSponsor"
                        style="margin-right: 20px">添加</a-button>
              <a-tag v-for="item in assistPersonsList"
                     :key="item.key"
                     closable
                     @close="delSponsor(item.key)">{{
                item.title
              }}</a-tag>
            </a-form-model-item>
          </a-col>
          <a-col :md="12"
                 :sm="24">
            <a-form-model-item label="预期开始时间"
                               prop="predictStime">
              <a-date-picker v-model="addOrUpdateForm.predictStime"
                             format="YYYY-MM-DD"
                             :disabled-date="disabledDate"
                             :disabled-time="disabledDateTime"
                             @change="beginOnChange" />
            </a-form-model-item>
          </a-col>
          <a-col :md="12"
                 :sm="24">
            <a-form-model-item label="预期处理时长"
                               prop="planTime">
              <a-input placeholder="请输入"
                       v-model="addOrUpdateForm.planTime" />
            </a-form-model-item>
          </a-col>
          <!-- <a-col :md="12" :sm="24">
            <a-form-model-item label="开始时间" prop="startTime">
              <a-date-picker
                v-model="addOrUpdateForm.startTime"
                show-time
                placeholder="开始时间"
                @change="beginOnChange"
              />
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item label="结束时间" prop="endTime">
              <a-date-picker v-model="addOrUpdateForm.endTime" show-time placeholder="结束时间" @change="endOnChange" />
            </a-form-model-item>
          </a-col> -->
          <a-col :md="24"
                 :sm="24">
            <a-form-model-item label="备注"
                               :label-col="{ span: 3 }"
                               :wrapper-col="{ span: 20 }">
              <a-textarea placeholder="多行输入"
                          v-model="addOrUpdateForm.deviceName"
                          :rows="2" />
            </a-form-model-item>
          </a-col>
          <a-col :md="24"
                 :sm="24">
            <a-form-model-item label="是否需要停水事件"
                               prop="isWaterOffEvent">
              <a-radio-group v-model="addOrUpdateForm.isWaterOffEvent"
                             @change="WaterOffEventchange">
                <a-radio :value="0">否</a-radio>
                <a-radio :value="1">是</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>

          <div v-if="WaterOf">
            <a-col :md="24"
                   :sm="24">
              <a-form-model-item label="事件名称"
                                 :label-col="{ span: 3 }"
                                 :wrapper-col="{ span: 20 }"
                                 prop="eventName">
                <a-input placeholder="请输入"
                         v-model="addOrUpdateForm.eventName"
                         :disabled="this.rOffEven" />
              </a-form-model-item>
            </a-col>
            <a-col :md="12"
                   :sm="24">
              <a-form-model-item label="爆管管段">
                <a-button type="primary"
                          @click="openMap">选择爆管管段</a-button>
              </a-form-model-item>
            </a-col>
            <a-col :md="12"
                   :sm="24">
              <a-form-model-item label="停水管理员"
                                 prop="waterAdminId">
                <a-select show-search
                          option-filter-prop="children"
                          :filter-option="filterOption"
                          v-model="addOrUpdateForm.waterAdminId">
                  <a-select-option v-for="item in userlist"
                                   :key="item.id">{{ item.realName }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :md="12"
                   :sm="24">
              <a-form-model-item label="开始分类编码"
                                 prop="startClassNo">
                <a-input v-model="addOrUpdateForm.startClassNo"
                         disabled />
              </a-form-model-item>
            </a-col>
            <a-col :md="12"
                   :sm="24">
              <a-form-model-item label="结束分类编码"
                                 prop="endClassNo">
                <a-input v-model="addOrUpdateForm.endClassNo"
                         disabled />
              </a-form-model-item>
            </a-col>
            <a-col :md="12"
                   :sm="24">
              <a-form-model-item label="计划停水开始时间"
                                 prop="startValues">
                <a-date-picker v-model="addOrUpdateForm.startValues"
                               :disabled-date="disabledStartDates"
                               @change="onChangehs"
                               format="YYYY-MM-DD HH:mm:ss"
                               @openChange="handleStartOpenChanges" />
              </a-form-model-item>
            </a-col>
            <a-col :md="12"
                   :sm="24">
              <a-form-model-item label="计划停水结束时间"
                                 prop="endValues">
                <a-date-picker v-model="addOrUpdateForm.endValues"
                               :disabled-date="disabledEndDates"
                               format="YYYY-MM-DD HH:mm:ss"
                               :open="endOpens"
                               @change="onChangets"
                               @openChange="handleEndOpenChanges" />
              </a-form-model-item>
            </a-col>
            <a-col :md="24"
                   :sm="24">
              <a-form-model-item label="事件描述"
                                 :label-col="{ span: 3 }"
                                 :wrapper-col="{ span: 20 }"
                                 prop="describe">
                <a-textarea placeholder="多行输入"
                            v-model="addOrUpdateForm.describe"
                            :rows="3" />
              </a-form-model-item>
            </a-col>
          </div>
        </a-row>
      </a-form-model>
      <addModal ref="addModal"
                @addPepople="addPepople"></addModal>
      <a-modal class="log-form"
               :title="'选取位置'"
               width="50%"
               v-model="showMap"
               @ok="closeMap"
               @cancel="closeMap2">
        <input class="login-input"
               type="text"
               v-model="startLine"
               placeholder="请输入开始分类编码" />
        <input class="login-input"
               type="text"
               v-model="endLine"
               placeholder="请输入结束分类编码" />
        <a-button type="submit"
                  @click="searchMapLine">查询</a-button>
        <mapTemplate ref="waterMap"
                     @childByValue="childByValue"></mapTemplate>
      </a-modal>
    </a-modal>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import moment from 'moment'
import addModal from './AddModal'
import LonlatMap from '../../../maintenance/EventManagement/modules/lonlatMap.vue'
import mapTemplate from '@/views/Water-outage-control/map-template.vue'
export default {
  components: {
    addModal,
    LonlatMap,
    dayjs,
    mapTemplate
  },
  data () {
    return {
      queryUrl: '/pipe-network/user_water_meters/page/geophysical-point-numbers',
      exportFileName: '影响用户数据.xlsx',
      exportDataUrl: 'pipe-network/user_water_meters/export',
      showTubeView: false,
      WaterOf: false,
      id: '',
      startLine: '',
      endLine: '',
      showMap: false,
      addOrUpdateForm: {
        predictStime: '',
        planTime: '',
        deviceNo: '',
        deviceName: '',
        workName: '',
        principal: '',
        pumpId: '',
        workOrderType: '',
        deviceName: '',
        maintenancePersons: [],
        maintainPersons: [],
        startValue: '',
        startValues: '',
        endValues: '',
        isWaterOffEvent: '',
        isRelationWaterOffEvent: 0,
        waterAdminId: '',
        startClassNo: '',
        endClassNo: '',
        describe: '',
        planStartTime: '',
        planEntTime: '',
        eventName: '',
        lineId: ''
      },
      zoneTreeData: [], // 分区数据选项
      eventTypeList: [],
      OrderTypeList: [], // 工单类型
      userlist: [],
      assistPersonsList: [],
      maintainPersonsList: [],
      selectButton: '',
      mapVisible: false,
      endOpens: false
    }
  },
  computed: {
    rules () {
      return {
        deviceName: [{ required: true, message: '请输入设备名称', trigger: 'change' }],
        workName: [{ required: true, message: '请输入工单名称', trigger: 'change' }],
        deviceNo: [{ required: true, message: '请输入设备编码', trigger: 'change' }],
        workOrderType: [{ required: true, message: '请选择工单类型', trigger: 'change' }],
        zoneId: [{ required: true, message: '请选择片区', trigger: 'change' }],
        principal: [{ required: true, message: '请选择负责人', trigger: 'change' }],
        pumpId: [{ required: true, message: '请选择维修泵房', trigger: 'change' }],
        maintainPersons: [{ required: true, message: '请选择督办人', trigger: 'change' }],
        // maintenancePersons: [{ required: true, message: '请选择其他维修人员', trigger: 'change' }],
        predictStime: [{ required: true, message: '请选择预期开始时间', trigger: 'change' }],
        planTime: [{ required: true, message: '请输入预期完成时长', trigger: 'change' }],
        address: [{ required: true, message: '请选择地址', trigger: 'change' }],
        deviceName: [{ required: true, message: '请输入任务描述', trigger: 'change' }],
        isWaterOffEvent: [{ required: true, message: '请选择是否需要停水事件', trigger: 'change' }],
        eventName: [{ required: true, message: '请输入事件名称', trigger: 'change' }],
        startValues: [{ required: true, message: '请选择停水开始时间', trigger: 'change' }],
        endValues: [{ required: true, message: '请选择停水结束时间', trigger: 'change' }],
        waterAdminId: [{ required: true, message: '请选择停水管理员', trigger: 'change' }],
        startClassNo: [{ required: true, message: '请输入开始分类编码', trigger: 'change' }],
        endClassNo: [{ required: true, message: '请输入结束分类编码', trigger: 'change' }],
        describe: [{ required: true, message: '请输入事件名称', trigger: 'change' }]
      }
    }
  },
  created () {
    this.getUserList()
    this.getOrderTypeList()
  },
  methods: {
    disabledDate (current) {
      return current && current < dayjs().endOf('day')
    },
    disabledDateTime () { },
    moment,
    childByValue (childValue) {
      this.startLine = childValue[0].properties.start_class_no
      this.endLine = childValue[0].properties.end_class_no
      this.addOrUpdateForm.lineId = childValue[0].id.substr(childValue[0].id.lastIndexOf('.') + 1, 20)
    },
    openMap () {
      this.showMap = true
      this.$refs.waterMap.redSource.clear()
    },
    closeMap () {
      this.addOrUpdateForm.endClassNo = this.endLine
      this.addOrUpdateForm.startClassNo = this.startLine
      this.startLine = ''
      this.endLine = ''
      this.showMap = false
      this.$refs.waterMap.redSource.clear()
    },
    closeMap2 () {
      this.showMap = false
      this.startLine = ''
      this.endLine = ''
      this.$refs.waterMap.redSource.clear()
    },
    searchMapLine () {
      this.$refs.waterMap.searchLines(this.startLine, this.endLine)
    },
    showmap () {
      this.mapVisible = true
    },
    disabledStartDates (current) {
      return current && current < dayjs().endOf('day')
    },
    disabledEndDates (endValue) {
      const startValue = this.addOrUpdateForm.startValues
      if (!endValue || !startValue) {
        return false
      }
      return startValue.valueOf() >= endValue.valueOf()
    },
    handleStartOpenChanges (open) {
      if (!open) {
        this.endOpens = true
      }
    },
    handleEndOpenChanges (open) {
      this.endOpens = open
    },
    onChangehs (date, dateString) {
      this.addOrUpdateForm.planStartTime = dateString
    },
    onChangets (date, dateString) {
      this.addOrUpdateForm.planEntTime = dateString
    },
    // 停水
    WaterOffEventchange (value) {
      if (value.target.value == 1) {
        this.WaterOf = true
      } else {
        this.WaterOf = false
      }
    },
    showmap () {
      this.mapVisible = true
    },
    handleMapOk (data) {
      this.addOrUpdateForm.address = data.address
      this.addOrUpdateForm.place = data.point
      console.log(this.addOrUpdateForm.address)
      console.log(this.addOrUpdateForm.place)
    },
    getOrderTypeList () {
      this.$http.get('/pipe-network/twice_water_pumps/list').then(({ data }) => {
        const list = []
        data.map((item) => {
          console.log(item)
          list.push({
            title: item.pumpName + ' (' + item.pumpNo + ')',
            key: item.id
          })
        })
        this.OrderTypeList = list
      })
    },
    addSupervisor () {
      this.selectButton = 'Supervisor'
      this.$refs.addModal.edit(this.addOrUpdateForm.maintainPersons)
    },
    addSponsor () {
      this.selectButton = 'Sponsor'
      this.$refs.addModal.edit(this.addOrUpdateForm.maintenancePersons)
    },
    addPepople (list) {
      if (this.selectButton == 'Sponsor') {
        this.assistPersonsList = list
        this.addOrUpdateForm.maintenancePersons = []

        list.length
          ? list.map((item) => {
            this.addOrUpdateForm.maintenancePersons.push(item.key)
          })
          : ''
        console.log(this.assistPersonsList)
        console.log(this.addOrUpdateForm.maintenancePersons)
      } else {
        this.maintainPersonsList = list
        this.addOrUpdateForm.maintainPersons = []
        list.length
          ? list.map((item) => {
            this.addOrUpdateForm.maintainPersons.push(item.key)
          })
          : ''
      }
    },
    delMaintain (key) {
      const i = this.maintainPersonsList.findIndex((item) => {
        return item.key == key
      })
      this.maintainPersonsList.splice(i, 1)
      const j = this.addOrUpdateForm.maintainPersons.indexOf(key)
      this.addOrUpdateForm.maintainPersons.splice(j, 1)
    },
    delSponsor (key) {
      const i = this.assistPersonsList.findIndex((item) => {
        return item.key == key
      })
      this.assistPersonsList.splice(i, 1)
      const j = this.addOrUpdateForm.maintenancePersons.indexOf(key)
      this.addOrUpdateForm.maintenancePersons.splice(j, 1)
    },
    handleChange (value) {
      this.addOrUpdateForm.principal = value
    },
    pumpChange (value) {
    },
    getUserList () {
      this.$http.get('/manager/users/list').then(({ data }) => {
        this.userlist = data
      })
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    beginOnChange (value, dateString) {
      this.addOrUpdateForm.predictStime = dateString + ' 00:00:00'
    },
    endOnChange (value, dateString) {
      this.addOrUpdateForm.endTime = dateString
    },
    edit (records) {
      this.addOrUpdateForm.pumpId = records.pumpId
      this.showTubeView = true
        ; (this.addOrUpdateForm = {
          predictStime: '',
          planTime: '',
          deviceNo: '',
          deviceName: '',
          workName: '',
          principal: '',
          pumpId: records.pumpId,
          workOrderType: '',
          deviceName: '',
          maintenancePersons: [],
          maintainPersons: [],
          startValues: '',
          endValues: '',
          isWaterOffEvent: '',
          waterAdminId: '',
          startClassNo: '',
          endClassNo: '',
          describe: '',
          planStartTime: '',
          planEntTime: '',
          isWaterOffEvent: '',
          isRelationWaterOffEvent: 0,
          eventName: '',
          lineId: ''
        }),
          this.$nextTick(() => {
            this.$refs.addOrUpdateForm.resetFields()
            this.addOrUpdateForm.eventId = records.id
            this.addOrUpdateForm.eventNo = records.eventNo
          })
    },
    // 获取数据
    getDataList () {
      this.dataListLoading = true
      const params = {
        geophysicalPointNumber: this.id,
        // geophysicalPointNumber: 'JS581',
        page: this.pagination.current,
        limit: this.pagination.pageSize
      }
      this.$http
        .get(this.queryUrl, {
          params
        })
        .then(({ data }) => {
          this.dataListLoading = false
          this.dataList = data.list || []
          this.pagination.total = data.total ? parseInt(data.total) : 0
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    handleOk (e) {
      e.preventDefault()
      this.$refs.addOrUpdateForm.validate((valid) => {
        if (valid) {
          this.$http
            .post('/pipe-network/inspection_tasks/dispatch/work/order', {
              id: this.currentId,
              sysType: '二次供水',
              ...this.addOrUpdateForm
            })
            .then((res) => {
              if (res.code === 0) {
                this.closeTubeView()
                this.$emit('handleOk')
                this.WaterOf = false
                return this.$message.success(res.message)
              }
            })
            .catch(() => { })
        }
      })
    },
    closeTubeView () {
      this.showTubeView = false
      this.$refs.addOrUpdateForm.resetFields()
      this.assistPersonsList = []
      this.maintainPersonsList = []
      this.WaterOf = false
      this.$emit('handleOk')
    }
  }
}
</script>

<style lang="less" scoped>
</style>
